<i class="{{class}}"  [attr.data-feather]="icons"></i>